import styles from "./index.module.scss";
import ChatHeader from "./components/chat-header";
import ChatList from "./components/chat-list";
import ChatInput from "./components/chat-input";
import { createContext, memo, useCallback, useState } from "react";
import cn from "classnames";
import { ImessageObject } from "@api/types/chat";
import useReduxState from "@hooks/useReduxState";

const initialReplyState: ImessageObject = {
  id: "",
  user: {
    username: "",
    uid: "",
    is_staff: false,
    avatar_url: "",
    id: "",
    expirience: 0,
  },
  message: "",
  likes: [],
  createdAt: Date.now(),
};

interface IReplyContext {
  reply: ImessageObject;
  // eslint-disable-next-line no-unused-vars
  setReply: (message: ImessageObject) => void;
  resetReply: () => void;
}

export const replyContext = createContext<IReplyContext>({
  reply: initialReplyState,
  setReply: (message: ImessageObject) => {
    console.log(message);
  },
  resetReply: () => {},
});

export function Chat(): JSX.Element {
  const [reply, setReply] = useState<ImessageObject>(initialReplyState);
  const [{ collapsed }, setChats] = useReduxState((state) => state.chat);

  const updateReply = (message: ImessageObject) => {
    setReply(message);
  };
  const resetReply = () => {
    setReply(initialReplyState);
  };

  const handleCollapse = useCallback(() => {
    setChats({
      type: "COLLAPSE_CHAT",
      arg: null,
    });
  }, [collapsed]);

  return (
    <replyContext.Provider
      value={{
        reply,
        setReply: updateReply,
        resetReply,
      }}
    >
      <div
        className={cn(styles.chat, {
          [styles.collapsed]: collapsed,
        })}
      >
        <ChatHeader collapsed={collapsed} onCollapse={handleCollapse} />
        <ChatList />
        <ChatInput />
      </div>
    </replyContext.Provider>
  );
}

export default memo(Chat);
